<template>
    <div class="modal fade show" id="sleepData" tabindex="-1" role="dialog" aria-labelledby="sleepData" aria-hidden="true" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Weight</h4>
                    <button type="button" class="close" @click.prevent="$parent.toggleForm()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <loader v-if="pageLoader"></loader>
                    <div class="form-group field-wrapper">
                        <input type="number" class="float-field form-control" placeholder="Enter Weight"  name="weight" v-model="weight" v-validate="'required|decimal:2'" />
                        <p class="error" v-if="submitted" v-for="error in errors.collect('weight')">{{ error }}</p>
                    </div>
                    <div class="Sleep_input">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="form-group field-wrapper">
                                <select class="float-field form-control" name="Unit" v-model="weightUnit" v-validate="'required'" >
                                    <option disabled value="">Select weight Unit...</option>
                                    <option v-for="(item,key) in weightOptions"  :value="item.value"> {{item.label}} </option>
                                </select>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('Unit')">{{ error }}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input class="float-field form-control" type="time" :max="disableFutureTime" name="time"v-model="time" v-validate="'required'">
                                <p class="error" v-if="submitted && errors.has('time')">Time field is required </p>
                                <p class="error" v-if="submitted && selectFutureTime">Please Select time before current time</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default red" data-dismiss="modal" @click.prevent="$parent.toggleForm()">Close</button>
                    <button type="button" class="btn btn-default btn-blue" @click.prevent="SaveWeightData()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    export default {
        name: "Weight-Form",
        data() {
            return {
                pageLoader : false,
                submitted : false,
                weightUnit: '',
                weight: '',
                time: '',
                disableFutureTime: moment().format("HH:mm"),
                selectFutureTime : false
            };
        },
        props:['from'],
        methods:{
            changeTime(){
                const d = new Date();
                if(this.time){
                    let hours = this.time.split(':')[0]
                    let minutes = this.time.split(':')[1]
                    if(this.from == '' || this.$parent.filter == 'today'){
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }else{
                        d.setDate(d.getDate()-1);
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }
                }
                return d
            },
            onFileChange(event){
                var fileData =  event;
                this.fileName = fileData.name;
            },
            SaveWeightData(){
                const _that = this
                let form_name = new FormData();
                _that.submitted = true;
                form_name.append("weight_time" , moment(_that.changeTime()).format('YYYY-MM-DD HH:mm'));
                form_name.append("weight" , _that.weight);
                form_name.append("unit" , _that.weightUnit);
                form_name.append("type" , 0);
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        const d = new Date();
                        let hrs = this.time.split(':')[0]
                        let mns = this.time.split(':')[1]
                        d.setHours(parseInt(hrs))
                        d.setMinutes(parseInt(mns))
                        if(this.$parent.filter != 'yesterday' && moment(d).diff(moment(),'minutes') > 0){
                            this.selectFutureTime = true
                        }else{
                            this.selectFutureTime = false
                            let input_json = {
                                'globalParams' : {
                                    "form" : form_name,
                                },'localParams' : {'parameter' : _that, 'type' :'form'}
                            }
                            if(this.from){
                                input_json.localParams.from = this.from
                            }
                            this._runAddWeight(input_json)
                        }
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.weight = ''
                this.weightUnit = ''
                this.time = ''
                this.selectFutureTime = false
            }   
        },
        created(){
           this.pageName('Input Weight Data')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/user/forms/weight-data.vue